import { IconTestTube } from '@posthog/icons';
import { CalloutBox } from 'components/Docs/CalloutBox';
import * as React from 'react';
export default {
  IconTestTube,
  CalloutBox,
  React
};